import React, { Component } from 'react';
import Header from './components/Header';
import Homepage from './components/Homepage';
import About from './components/About';
import Contact from './components/Contact';
import Footer from './components/Footer';
import './App.scss';
import {
	BrowserRouter as Router,
	Route,
	Switch
} from 'react-router-dom';

class App extends Component {

	render() {
		return (
			<Router basename={process.env.PUBLIC_URL}>
				<div className="main-app-wrapper">
					<Header />
					<Switch>
						<Route path="/" component={Homepage} exact={true} />
						<Route path="/about" component={About} />
						<Route path="/contact" component={Contact} />
					</Switch>
					<Footer />
				</div>
			</Router>
		);
	}
}

export default App;
